<template>
  <div>
    <top-message />
    <div class="content">
      <div>
        <el-form
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
          style="padding: 20px 30px 0"
        >
          <el-form-item>
            <el-button
              @click="exportAuthBook(searchForm)"
              style="width:120px; font-size: 12px;"
              type="primary"
            >
              <i class="el-icon-download"></i>授权企业导出
            </el-button>
          </el-form-item>
          <el-form-item label="申请状态">
            <el-select
              v-model="searchForm.auditStatus"
              placeholder="请选择"
              style="width: 120px"
              clearable
            >
              <el-option
                v-for="item in statusOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              style="width: 200px;"
              placeholder="请输入被授权单位企业信用代码"
              v-model="searchForm.enterpriseCode"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              style="width: 200px;"
              placeholder="请输入企业名称统一社会信用代码"
              v-model="searchForm.licenseCode"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">搜索</el-button>
            <el-button
              @click="exportData(searchForm)"
              style="width: 120px; font-size: 12px; "
              type="primary"
            >
              <i class="el-icon-download"></i>授权数据导出
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="padding-left:30px;" v-if="getSourceType == 6">
        <el-button :disabled="selectedItems.length === 0" @click="batchUpload" type="primary">批量上报</el-button>
      </div>
      <div style="padding: 0">
        <el-table @selection-change="handleSelectionChange" :data="tableData" style="width: 100%;">
          <el-table-column :selectable="selectable" type="selection" width="55"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="enterpriseName" label="企业名称">
            <template slot-scope="{ row }">
              <span>{{ row.enterpriseName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="enterpriseCode" label="企业统一社会信用代码">
            <template slot-scope="{ row }">
              <span>{{ row.enterpriseCode }}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="licenseCode" label="被授权单位统一社会信用代码">
            <template slot-scope="{ row }">
              <!-- <span>{{ $moment(row.createTime).format('YYYY-MM-DD HH:mm')}}</span> -->
              <span>{{row.licenseCode}}</span>
            </template>
          </el-table-column>
          <el-table-column label="授权起止时间">
            <template slot-scope="{ row }">
              <span>{{row.startTime+ row.endTime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="licenseNum" label="授权查询次数">
            <template slot-scope="{ row }">
              <span>{{ row.licenseNum }}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="licenseId" label="授权协议标识">
            <template slot-scope="{ row }">
              <span>{{ row.licenseId }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="optionTime" label="操作时间">
            <template slot-scope="{ row }">
              <span>{{ row.optionTime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="auditStatus" label="审核状态">
            <template slot-scope="{ row }">
              <span>{{ row.auditStatus==1?'已同意':row.auditStatus==3?'已撤销':row.auditStatus==4?'已上报':'' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="licenseNum" label="授权书剩余可查询次数">
            <template slot-scope="{ row }">
              <el-button @click="countDetail(row)" type="text">查询</el-button>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="{ row }">
              <el-button @click="detailLook(row)" type="text">详情</el-button>
              <el-button
                :disabled="selectedItems.id == row.id"
                v-if="row.auditStatus=='1'"
                @click="agreeUpload(row)"
                type="text"
              >协议上报</el-button>
              <el-button v-if="row.auditStatus=='4'" @click="agreeRevoke(row)" type="text"><span>|</span>协议撤销</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="text-align: right; margin-top:30px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40,50]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="cuntTotal"
        ></el-pagination>
      </div>
    </div>
    <!-- 详情 -->
    <div>
      <el-dialog
        title="企业授权协议详情"
        @close="detailCloseDialog"
        :visible.sync="dialogVisible"
        width="60%"
      >
        <div>
          <div>
            <span class="lines"></span>
            <span>基本信息</span>
            <div>
              <el-form label-width="200px">
                <el-form-item label="企业名称:">{{detailValue.enterprise_name }}</el-form-item>
                <el-form-item label="企业统一社会信用代码:">
                  <span>{{ detailValue.enterprise_code }}</span>
                </el-form-item>
                <el-form-item label="授权查询信息列表:">
                  <span>{{ detailValue.license_list }}</span>
                </el-form-item>
                <el-form-item label="被授权单位名称:">
                  <span>{{ detailValue.license_name }}</span>
                </el-form-item>
                <el-form-item label="被授权单位统一社会信用代码:">
                  <span>{{ detailValue.license_code }}</span>
                </el-form-item>
                <el-form-item label="授权起止时间:">
                  <span>{{ detailValue.license_time }}</span>
                </el-form-item>
                <el-form-item label="授权查询次数:">
                  <span>
                    {{ detailValue.license_num }}
                  </span>
                </el-form-item>
                <el-form-item
                  label="贷款阶段:"
                >{{ detailValue.loan_period==1?'贷前':detailValue.loan_period==2?'贷后':detailValue.loan_period==3?'不限':''}}</el-form-item>
                <el-form-item
                  label="状态:"
                >{{ detailValue.audit_status==1?'已同意':detailValue.audit_status==3?'已撤销':detailValue.audit_status==4?'已上传':'' }}</el-form-item>
                <el-form-item label="授权协议标识:">
                  <span>{{ detailValue.licenseid }}</span>
                </el-form-item>
              </el-form>
            </div>
          </div>

          <div>
            <span class="lines"></span>
            <span>附件信息</span>
            <p @click="downPdf">{{ detailValue.attachment }}</p>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 查询次数 -->
    <div>
      <el-dialog
        title="授权书剩余可查询次数"
        @close="countDetailCloseDialog"
        :visible.sync="dialogVisible2"
        width="700px"
      >
        <div>
          <div>
            <div class="bigRow">
              <el-row :gutter="24" class="rowDiv">
                <el-col :span="12" class="colDiv" style="font-size: 16px;font-weight: bold;">接口名称</el-col>
                <el-col :span="8" class="colDiv" style="font-size: 16px;font-weight: bold;">剩余可查询次数</el-col>
              </el-row>
              <el-row :gutter="24" class="rowDiv">
                <el-col :span="12" class="colDiv">非正常纳税户剩余查询次数:</el-col>
                <el-col :span="8" class="colDiv">{{showInfo.fzcnsh}}</el-col>
              </el-row>
              <el-row :gutter="24" class="rowDiv">
                <el-col :span="12" class="colDiv">法人用电信息剩余查询次数:</el-col>
                <el-col :span="8" class="colDiv">{{showInfo.acapSvcpre}}</el-col>
              </el-row>
              <el-row :gutter="24" class="rowDiv">
                <el-col :span="12" class="colDiv">企业名下不动产剩余查询次数:</el-col>
                <el-col :span="8" class="colDiv">{{showInfo.frbdcdj}}</el-col>
              </el-row>
              <el-row :gutter="24" class="rowDiv">
                <el-col :span="12" class="colDiv">欠税信息剩余查询次数:</el-col>
                <el-col :span="8" class="colDiv">{{showInfo.qsxx}}</el-col>
              </el-row>
              <el-row :gutter="24" class="rowDiv">
                <el-col :span="12" class="colDiv">增值税缴税信息剩余查询次数:</el-col>
                <el-col :span="8" class="colDiv">{{showInfo.zzsnssb}}</el-col>
              </el-row>
              <el-row :gutter="24" class="rowDiv">
                <el-col :span="12" class="colDiv">企业名下不动产抵押剩余查询次数:</el-col>
                <el-col :span="8" class="colDiv">{{showInfo.frfcdy}}</el-col>
              </el-row>
              <el-row :gutter="24" class="rowDiv">
                <el-col :span="12" class="colDiv">企业所得税缴税剩余查询次数:</el-col>
                <el-col :span="8" class="colDiv">{{showInfo.qysds}}</el-col>
              </el-row>
              <el-row :gutter="24" class="rowDiv">
                <el-col :span="12" class="colDiv">社保费欠费信息剩余查询次数:</el-col>
                <el-col :span="8" class="colDiv">{{showInfo.sbfqs}}</el-col>
              </el-row>
              <el-row :gutter="24" class="rowDiv">
                <el-col :span="12" class="colDiv">法人用电欠费信息剩余查询次数:</el-col>
                <el-col :span="8" class="colDiv">{{showInfo.legalArrears}}</el-col>
              </el-row>
              <el-row :gutter="24" style="text-align: right;margin-top:20px">
                <el-button @click="dialogVisible2 = false" type="primary" siz\e>确定</el-button>
              </el-row>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 协议上传 -->
    <div>
      <el-dialog
        @close="handleCloseDialog"
        :destroy-on-close="true"
        title="协议上传"
        :visible.sync="dialogUpload"
        width="60%"
      >
        <div>
          <div>
            <el-form ref="formRef" :rules="rules" :model="modeUploadForm" label-width="240px">
              <el-form-item label="企业名称:">
                <el-input disabled v-model="modeUploadForm.enterpriseName" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="统一社会信用代码:">
                <el-input disabled v-model="modeUploadForm.enterpriseCode" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item prop="licenseList" label="授权查询信息列表:">
                <el-input disabled v-model="modeUploadForm.licenseList" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item prop="licenseCode" label="被授权单位统一社会信用代码列表:">
                <el-input disabled v-model="modeUploadForm.licenseCode" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item prop="licenseSource" label="授权来源:">
                <el-select v-model="modeUploadForm.licenseSource" placeholder="请选择">
                  <el-option label="金融机构" value="1"></el-option>
                  <el-option label="融资平台" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="地方平台编码:">
                <el-input disabled v-model="modeUploadForm.platformId" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="授权查询次数:">
                <el-input v-model="modeUploadForm.licenseNum" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item prop="loanPeriod" label="贷款阶段:">
                <el-select v-model="modeUploadForm.loanPeriod" placeholder="请选择">
                  <el-option label="贷前" value="1"></el-option>
                  <el-option label="贷后" value="2"></el-option>
                  <el-option label="不限" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="licenseType" label="授权协议类型:">
                <el-select
                  @change="handleFileTypeChange"
                  v-model="modeUploadForm.licenseType"
                  placeholder="请选择"
                >
                  <el-option label="普通文件" value="1"></el-option>
                  <el-option label="电子签章" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :required="modeUploadForm.licenseType=='2'"
                prop="caSupplier"
                label="电子签章供应商:"
              >
                <el-input disabled v-model="modeUploadForm.caSupplier" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item
                :required="modeUploadForm.licenseType=='2'"
                prop="validateUrl"
                label="验证地址:"
              >
                <el-input disabled v-model="modeUploadForm.validateUrl" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="授权起止时间:">
                <el-date-picker
                  disabled
                  v-model="modeUploadForm.licenseTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="授权协议上传:">
                <el-input disabled v-model="modeUploadForm.attachment" autocomplete="off"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogUpload=false">取 消</el-button>
          <el-button type="primary" @click="submitUpload">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  authMangList,
  authMangDetail,
  authMangExport,
  authMangExportData,
  authUpload,
  selectQueryNumList
  // authClose
} from "../../api/authmanget";
import baseUrl from "@/api/baseUrl";
import TopMessage from "@/components/TopMessage";
export default {
  components: { TopMessage },
  data() {
    return {
      dialogVisible: false,
      dialogVisible2: false,
      dialogUpload: false,
      searchForm: {
        enterpriseCode: "",
        licenseCode: "",
        auditStatus: "",
        page: 1,
        pageSize: 10
      },
      selectedItems: [], //选中的项目
      modeUploadForm: {
        // enterpriseName: "",
        // enterpriseCode: "",
        // licenseList: "",
        // licenseCode: "",
        // licenseSource: "",
        // platformId: "",
        // licenseNum: "",
        // loanPeriod: "",
        // licenseType: "",
        // caSupplier: "",
        // validateUrl: "",
        // file: "",
        // licenseTime: ""
      },

      cuntTotal: 0,
      statusOption: [
        {
          label: "待审核",
          value: "0"
        },
        {
          label: "已同意",
          value: "1"
        },
        {
          label: "已拒绝",
          value: "2"
        },
        {
          label: "已撤销",
          value: "3"
        },
        {
          label: "已上传",
          value: "4"
        }
      ],
      showInfo :{
        fzcnsh: 0,        //非正常纳税户剩余查询次数    
        acapSvcpre: 0,	//法人用电信息剩余查询次数
        frbdcdj: 0,		//企业名下不动产剩余查询次数
        qsxx: 0,			//欠税信息剩余查询次数
        zzsnssb: 0,		//增值税缴税信息剩余查询次数
        frfcdy: 0, 		//企业名下不动产抵押剩余查询次数
        qysds: 0,			//企业所得税缴税剩余查询次数
        sbfqs: 0,			//社保费欠费信息剩余查询次数
        legalArrears: 0  //法人用电欠费信息剩余查询次数
      },
      tableData: [],
      detailValue: {},
      rules: {
        // licenseList: [
        //   { required: true, message: "请输入", trigger: "blur" }
        // ],
        // licenseCode: [
        //   { required: true, message: "请输入", trigger: "blur" }
        // ],
        // licenseSource: [{ required: true, message: "请选择", trigger: "change" }],
        // loanPeriod: [{ required: true, message: "请选择", trigger: "change" }],
        // licenseType: [
        //   { required: true, message: "请选择", trigger: "change" }
        // ],
        caSupplier: [],
        validateUrl: []
      }
    };
  },
  mounted() {
    this.authMangListApi();
  },
  computed: {
    getSourceType: function() {
      return this.$store.getters.sourceType;
    },
    organization: function() {
      return this.$store.getters.organization
        ? this.$store.getters.organization
        : "";
    }
  },
  methods: {
    // 当下拉框值改变时，清除之前的验证结果
    handleFileTypeChange(value) {
      if (value === "2") {
        // 设置默认值，但允许用户修改
        this.modeUploadForm.caSupplier = "敏行信息技术有限公司";
        this.modeUploadForm.validateUrl =
          "http://121.236.214.139:8098/ses/fileVerify";
        // 2. 动态添加必填规则
        this.rules.caSupplier = [
          {
            required: true,
            message: "电子签章供应商不能为空",
            trigger: ["blur", "change"]
          }
        ];
        this.rules.validateUrl = [
          {
            required: true,
            message: "验证地址不能为空",
            trigger: ["blur", "change"]
          }
        ];
      } else {
        this.rules.caSupplier = [];
        this.rules.validateUrl = [];
        this.modeUploadForm.caSupplier = "";
        this.modeUploadForm.validateUrl = "";
      }
      this.$refs.formRef.clearValidate("caSupplier");
      this.$refs.formRef.clearValidate("validateUrl");
      // 4. 手动触发表单验证
      this.$nextTick(() => {
        this.$refs.formRef.validateField("caSupplier");
        this.$refs.formRef.validateField("validateUrl");
      });
    },
    // 授权企业书导出
    async exportAuthBook(searchForm) {
      try {
        const { filename, blobData, contentType } = await authMangExport(
          searchForm
        );
        const blob = new Blob([blobData], {
          type: contentType
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        // 设置下载文件名（可以从响应头获取，也可以固定）
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // 释放URL对象
        window.URL.revokeObjectURL(downloadUrl);
      } catch (error) {
        this.$message.error("导出失败，请重试");
      }
    },
    // 授权数据导出
    async exportData(searchForm) {
      try {
        const { filename, blobData, contentType } = await authMangExportData(
          searchForm
        );
        const blob = new Blob([blobData], {
          type: contentType
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        // 设置下载文件名（可以从响应头获取，也可以固定）
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // 释放URL对象
        window.URL.revokeObjectURL(downloadUrl);
      } catch (error) {
        this.$message.error("导出失败，请重试");
      }
    },
    // 搜索
    onSubmit() {
      this.authMangListApi();
    },
    // 列表接口数据
    async authMangListApi() {
      const res = await authMangList({
        ...this.searchForm,
        organization: this.organization
      });
      this.tableData = res.data.data.list;
      this.cuntTotal = res.data.data.total;
    },
    selectable(row, index) {
      return row.auditStatus === "1";
    },

    // 多选
    handleSelectionChange(val) {
      this.selectedItems = val;
    },
    // 批量上传
    batchUpload() {
      if (this.selectedItems.length === 0) {
        this.$message.warning("请至少选择一条数据");
        return;
      }
      // 再次确认所有选中项都是"已同意"状态
      const hasInvalidItems = this.selectedItems.some(
        item => item.auditStatus !== "1"
      );
      if (hasInvalidItems) {
        this.$message.warning('只能选择审核状态为"已同意"的数据');
        return;
      }

      this.$confirm(
        `确定要上传选中的 ${this.selectedItems.length} 条数据吗?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(async () => {
        const res = await authUpload(this.selectedItems);
        console.log(res, "this.selectedItems");

        // this.uploadItems(this.selectedItems)
      });
    },

    // 确定提交上传接口方法
    async submitUpload() {
      try {
        const valid = await this.$refs.formRef.validate();
        if (!valid) return;
        let modeUploadForm = {
          ...this.modeUploadForm,
          startTime: this.modeUploadForm.licenseTime[0],
          endTime: this.modeUploadForm.licenseTime[1]
        };
        delete modeUploadForm.licenseTime;
        const res = await authUpload([modeUploadForm]);
        console.log(res, "res");

        // if (res.data.code == 200) {
        //   this.$message.success("文档提交成功");
        // }
      } catch (error) {
        console.error("提交失败:", error);
        // this.$message.error(error.res?.data?.message || "文档提交失败");
      }
    },

    handleCloseDialog() {
      // 弹窗关闭表单重置
      this.$refs.formRef.resetFields();
      this.modeUploadForm = {
        enterpriseName: "",
        enterpriseCode: "",
        licenseList: "",
        licenseCode: "",
        licenseSource: "",
        platformId: "",
        licenseNum: "",
        loanPeriod: "",
        licenseType: "",
        caSupplier: "",
        validateUrl: "",
        licenseTime: ""
      };
      // this.file = [];
    },

    // 协议上传
    agreeUpload(row) {
      if (row.auditStatus !== "1") {
        this.$message.warning('只有审核状态为"已同意"的数据才能上传');
        return;
      }
      this.modeUploadForm = {
        ...row,
        enterpriseName: row.enterpriseName,
        enterpriseCode: row.enterpriseCode, //统一社会信用代码
        licenseList: row.licenseList, //授权信息查询列表
        licenseCode: row.licenseCode, //被授权单位统一社会信息代码列表
        licenseSource: row.licenseSource, //授权来源
        platformId: row.platformId, //地方平台编码
        licenseNum: row.licenseNum, //授权查询次数
        loanPeriod: row.loanPeriod, //贷款阶段
        licenseType: row.licenseType, //授权协议类型
        caSupplier: row.caSupplier, //电子签章供应商
        validateUrl: row.validateUrl, //验证地址
        licenseTime: [row.startTime, row.endTime], //授权起止时间
        attachment: row.attachment //附件信息
      };

      this.dialogUpload = true;
    },
    // 协议撤销
    async agreeRevoke(row) {
      console.log(row);
      // const res = await authClose();
    },
    // 详情接口
    async authMangDetailApi(id) {
      const res = await authMangDetail({ id });
      this.detailValue = res.data.data;
      console.log(res, "详情");
    },
    // 详情
    detailLook(row) {
      this.dialogVisible = true;
      this.authMangDetailApi(row.id);
    },
    countDetail(row){
      //接口
      let params = {
        id:row.licenseId,
        organization: this.organization
      }
      selectQueryNumList(params).then(res=>{
        if(res.data.data!=null){
          let {fzcnsh,acapSvcpre,frbdcdj,qsxx,zzsnssb,frfcdy,qysds,sbfqs,legalArrears} =res.data.data
          this.showInfo = {
            fzcnsh,        //非正常纳税户剩余查询次数    
            acapSvcpre,	//法人用电信息剩余查询次数
            frbdcdj,		//企业名下不动产剩余查询次数
            qsxx,			//欠税信息剩余查询次数
            zzsnssb,		//增值税缴税信息剩余查询次数
            frfcdy, 		//企业名下不动产抵押剩余查询次数
            qysds,			//企业所得税缴税剩余查询次数
            sbfqs,			//社保费欠费信息剩余查询次数
            legalArrears  //法人用电欠费信息剩余查询次数
          }
        }
        this.dialogVisible2 = true;
      })
      
    },
    // 详情附件下载
    downPdf() {
      // 编码转译
      const filname = this.detailValue.attachment;
      const encodedPath = encodeURIComponent(filname);
      const xhr = new XMLHttpRequest();
      xhr.open(
        "get",
        this.baseUrl +
          `/api/v1/bankLicense/downloadFile?fileName=${encodedPath}`,
        true
      ); // get、post都可
      xhr.responseType = "blob"; // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.onload = function() {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = filname;
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a");
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };
      xhr.send();
    },

    detailCloseDialog() {
      this.dialogVisible = false;
    },
    countDetailCloseDialog(){
      this.dialogVisible2 = false;
    },
    // 分页
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.authMangListApi(this.searchForm);
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.authMangListApi(this.searchForm);
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  min-height: 787px;
  background: #fff;
  box-sizing: border-box;
  padding-top: 20px;
  font-size: 14px;
  border-radius: 6px;
  margin-top: 20px;
}
.lines {
  width: 3px;
  height: 15px;
  background: #0081cc;
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
}
.bigRow{
  width: 500px;
  margin: 0 auto;
  font-size: 14px;
  color: #606266;
  .rowDiv{
    .colDiv{
      line-height: 30px;
      text-align: center;
    }
  }
}

</style>